import React from 'react';
import { useEffect } from 'react';
import { useFieldArray } from 'react-hook-form';
import TemplateBodyField from '../../components/template-body-field';
import MediaCarouselCard from './Media-Carousel-card';
import styles from '../../stylesheets/carouselCard.module.css';
import { Button } from 'primereact/button';
import { ReactComponent as StarIcon } from '../../../../../assets/svgIcons/star.svg';

const MediaCarouselEditor = ({
  control,
  setValue,
  textAreaRef,
  getFormErrorMessage,
  SPAM_SUGGESTIONS,
  showSpamSuggestions,
  setShowSpamSuggestions,
  checkForSpam,
  messsageVariables,
  menuRef,

  showEmoji,
  setShowEmoji,
  handleEmojiClick,

  tempVariables,
  handleEditVariable,
  handleDeleteVariable,
  watchContent,
  watch,
  ...props
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'carouselCards',
  });

  const addCard = () => {
    if (fields.length >= 10) return;

    append({
      mediaType: 'IMAGE',
      media: null,
      cardText: '',
      buttons: [],
    });
  };

  useEffect(() => {
    if (fields.length === 0) {
      addCard();
    }
  }, []);
  return (
    <>
      {/* BODY */}

      <TemplateBodyField
        control={control}
        textAreaRef={textAreaRef}
        getFormErrorMessage={getFormErrorMessage}
        SPAM_SUGGESTIONS={SPAM_SUGGESTIONS}
        showSpamSuggestions={showSpamSuggestions}
        setShowSpamSuggestions={setShowSpamSuggestions}
        checkForSpam={checkForSpam}
        messsageVariables={messsageVariables}
        menuRef={menuRef}
        showEmoji={showEmoji}
        setShowEmoji={setShowEmoji}
        handleEmojiClick={handleEmojiClick}
        tempVariables={tempVariables}
        handleEditVariable={handleEditVariable}
        handleDeleteVariable={handleDeleteVariable}
        watchContent={watchContent}
        bodyLabel="Body (applies to all cards)"
      />

      {/* CARDS */}

      <div className="mt-4">
        <h3>Carousel</h3>
        <div className="flex flex-column gap-2">
          {fields.map((card, index) => (
            <MediaCarouselCard
              key={card.id}
              index={index}
              control={control}
              removeCard={remove}
              setValue={setValue}
            />
          ))}
        </div>

        {fields.length < 10 && (
          <div className="mt-3 w-full">
            <Button type="button" className={styles.addCardBtn} onClick={addCard}>
              <span>
                {' '}
                <StarIcon /> Add Card{' '}
              </span>
            </Button>
          </div>
        )}
      </div>
    </>
  );
};

export default MediaCarouselEditor;
